export type Hospitality = {
    id: string;
    name: string;
    enabled: boolean;
    liftOperatorId: string;
    dtaPointOfSaleName: string;
    sellingGroups: string[];
    beiPassword: string;
    beiUsername: string;
};

export type HospitalityUserWithCredentials = {
    password: string;
    username: string;
} & Hospitality;

export const createEmptyHospitalityUserWithCredentials = (
    liftOperatorId: string
): HospitalityUserWithCredentials => ({
    id: '',
    name: '',
    enabled: false,
    liftOperatorId,
    dtaPointOfSaleName: '',
    sellingGroups: [],
    beiPassword: '',
    beiUsername: '',
    username: '',
    password: '',
});
